import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=cd24de8a&scoped=true&"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackDialog.vue?vue&type=style&index=0&id=cd24de8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd24de8a",
  null
  
)

component.options.__file = "FeedbackDialog.vue"
export default component.exports